/**
 * ForYouSection — Account Settings section for managing "For You" preferences.
 * Embeds the ForYouPreferencePicker in compact mode.
 */
import React from 'react';
import ForYouPreferencePicker from '../../forYou/ForYouPreferencePicker.mjs';

export default function ForYouSection() {
    return (
        <div className="settings-section" id="for-you-section">
            <div className="settings-section-header">
                <h3 className="settings-section-title">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px', verticalAlign: 'text-bottom' }}>
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    For You
                </h3>
                <p className="settings-section-desc">
                    Choose which categories and topics appear in your personalized "For You" section.
                </p>
            </div>
            <ForYouPreferencePicker compact={true} showSave={true} />
        </div>
    );
}
